import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";

import { StyledCheckboxInput, TextInput } from "../../../../common/form";

const CloseFollowUp = (props) => {
  return (
    <div>
      <h5>
        <FormattedMessage id="members.followUps.form.action" />
      </h5>
      <div
        className={
          "close-follow-up" +
          (props.followUpStatusType == "CLOSED"
            ? " closed-follow-up"
            : props.closeFollowUp
            ? " closing-follow-up"
            : "")
        }
      >
        <Field
          id="closeFollowUp"
          name="closeFollowUp"
          component={StyledCheckboxInput}
          type="checkbox"
          checkbox={{ value: true }}
          label={
            props.followUpStatusType === "CLOSED" ? (
              <FormattedMessage id="members.followUps.form.closedFollowUp" />
            ) : (
              <FormattedMessage id="members.followUps.form.closeFollowUp" />
            )
          }
        />
        {props.followUpStatusType == "CLOSED" ? (
          <div className="closed-info">
            <Field
              id="followUpClosedOn"
              name="followUpClosedOn"
              type="text"
              component={TextInput}
              isStatic={true}
              label={
                <FormattedMessage id="members.followUps.form.followUpClosedOn" />
              }
            />
            <Field
              id="followUpClosedBy"
              name="followUpClosedBy"
              type="text"
              component={TextInput}
              isStatic={true}
              label={
                <FormattedMessage id="members.followUps.form.followUpClosedBy" />
              }
            />
            {props.closedDescription && (
              <Field
                groupClassName="close-follow-up-reason"
                id="closedDescription"
                name="closedDescription"
                component={TextInput}
                type="textarea"
                componentClass="textarea"
                isStatic={true}
                label={
                  <FormattedMessage id="members.followUps.form.closeFollowUpReason" />
                }
              />
            )}
          </div>
        ) : (
          <div className="closing-info">
            {props.closeFollowUp && (
              <Field
                groupClassName="close-follow-up-reason"
                id="closedDescription"
                name="closedDescription"
                component={TextInput}
                type="textarea"
                componentClass="textarea"
                label={
                  <FormattedMessage id="members.followUps.form.closeFollowUpReason" />
                }
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

CloseFollowUp.propTypes = {
  closedDescription: PropTypes.string,
  closeFollowUp: PropTypes.bool,
  followUpStatusType: PropTypes.string,
};

export default CloseFollowUp;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/CloseFollowUp.js